module.exports = __webpack_public_path__ + "static/img/5.83be54d1.png";